import { getObject} from "../ChoiceApi";
export interface IInactiveProcedureLines {
    claim_id: number;
    procedure_code: string;
    paid_totals: number;
    adj_totals: number;
   
}

export async function getInactiveLines(deposit_id: number):Promise<IInactiveProcedureLines [] | undefined>{
    return await getObject(`api/Deposits/InactiveProcedureLineView/${deposit_id}`);
}